<template>
  <div>
    <a-drawer :width="960" :visible="visible" :ok-button-props="{ props: { loading: loading } }" :body-style="{ paddingBottom: '80px' }" @close="close">
      <template slot="title">
        <span> 会议信息 </span>
      </template>
      <a-tabs v-model="tabsCurrent" :default-active-key="0" size="small" @change="handleTabsChange">
        <a-tab-pane v-for="(item ,index) in dataList" :key="index" :tab="item.review_time">
          <ReviewLog ref="reviewRef" :data="item" @changeStatus="changeStatus" />
        </a-tab-pane>
      </a-tabs>
    </a-drawer>
  </div>
</template>
<script>
import { userList } from '@/api/system/auth';
import store from '@/store';
import ReviewLog from './ReviewLog.vue';

export default {
  components: { ReviewLog },
  data() {
    return {
      key: 0,
      spinning: false,
      loading: false,
      visible: false,
      dataList: {},
      tabsCurrent: 0,
      userData: []
    };
  },
  computed: {
    productOperationList() {
      const list = [];
      if (store.state.globalConfigList) {
        const orgList = store.state.globalConfigList.pmom || [];
        return orgList.map(item => {
          return {
            nickname: item.nickname,
            id: item.user_id
          };
        });
      }
      return list;
    }
  },
  methods: {
    handleTabsChange() {

    },
    open(datas) {
      const list = datas || [];
      const sorted = list.slice().sort((a, b) => b.id - a.id);
      this.dataList = sorted;
      this.visible = true;
      this.getUserList();
    },
    close() {
      this.visible = false;
      this.loading = false;
      this.key++;
      this.$emit('close');
    },

    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    },
    changeStatus() {
      this.$emit('changeStatus');
    }
  }
};
</script>

<style lang="less" scoped>

.submit {
  width: 100px;
  margin: 0 auto;
}
/deep/.ant-modal-body {
  padding: 8px 48px 16px 48px;
}
/deep/.ant-drawer-body{
  padding: 5px 24px 24px;

}

</style>
